import { Directive, ElementRef, NgModule, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Constants } from '@app/common/constants';
import { Component } from '@app/models/component';
import { ComponentState } from '@app/models/component-state';
import { CacheService } from '@app/services/cache.service';
import { ComponentStatesOnRoutesService } from '@app/services/component-states-on-routes.service';

@Directive({
  selector: '[appMarkComponentVisited]'
})
export class MarkComponentVisitedDirective implements OnInit {

  constructor(
    private cacheService: CacheService,
    private elementRef: ElementRef,
    private router: Router,
    private componentStatesOnRoutesService: ComponentStatesOnRoutesService) { }

  ngOnInit(): void {
    this.cacheService.set(`${this.elementRef.nativeElement.localName}-${Constants.COMPONENT_VISITED_CACHEKEY_SUFFIX}`, new Date().toISOString());
    const componentConfigMap = {};
    const htmlElement = this.elementRef.nativeElement as HTMLElement;
    const attributeNames = htmlElement.getAttributeNames();

    attributeNames.forEach(name => {
      if (name && name.indexOf('ng') === -1) {
        const attributeValue = htmlElement.getAttribute(name);
        if (attributeValue) {
          componentConfigMap[name.toLocaleLowerCase()] = attributeValue;
        }
      }
    });

    this.componentStatesOnRoutesService.updateStates(
      new ComponentState({
        ComponentId: this.elementRef.nativeElement.localName,
        Routes: [this.router.url],
        ShowBadge: false,
        Refresh: false,
        Component: new Component({ Configurations: componentConfigMap }),
        LastCheckedForNewContent: new Date()
      }));
  }
}
@NgModule({
  declarations: [MarkComponentVisitedDirective],
  exports: [MarkComponentVisitedDirective],
})
export class MarkComponentVisitedModule { }
